import type { ThemeConfig } from 'antd';
import { theme as antdTheme } from 'antd';

/**
 * antd ConfigProvider 主题。集中管理品牌色 / 圆角等设计 token。
 */
export const themeConfig: ThemeConfig = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorPrimary: '#e85d35',
    colorInfo: '#2563eb',
    colorSuccess: '#16855b',
    colorWarning: '#c77b16',
    colorError: '#d14343',
    colorText: '#202124',
    colorTextSecondary: '#6f706f',
    colorTextTertiary: '#9a9a96',
    colorBorder: '#e8e6e1',
    colorBorderSecondary: '#efede8',
    colorBgBase: '#fbfaf7',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f5f3ef',
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    fontSize: 14,
    fontFamily:
      'Inter, "SF Pro Display", "SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif',
    controlHeight: 38,
    controlHeightLG: 44,
    boxShadow: '0 1px 2px rgba(24, 24, 22, 0.04), 0 8px 28px rgba(24, 24, 22, 0.05)',
    boxShadowSecondary: '0 12px 36px rgba(24, 24, 22, 0.08)',
    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: 'rgba(251, 250, 247, 0.88)',
      siderBg: '#171816',
      bodyBg: '#f5f3ef',
    },
    Menu: {
      darkItemBg: '#171816',
      darkSubMenuItemBg: '#171816',
      darkItemColor: '#a7a9a5',
      darkItemHoverColor: '#ffffff',
      darkItemSelectedColor: '#ffffff',
      darkItemHoverBg: '#242522',
      darkItemSelectedBg: '#2b2c28',
      itemBorderRadius: 10,
      itemMarginInline: 10,
      itemMarginBlock: 3,
    },
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
      fontWeight: 600,
    },
    Card: {
      headerBg: '#ffffff',
      paddingLG: 22,
    },
    Table: {
      headerBg: '#faf9f6',
      headerColor: '#5f605d',
      headerSplitColor: 'transparent',
      borderColor: '#efede8',
      rowHoverBg: '#faf8f4',
      cellPaddingBlock: 13,
      cellPaddingInline: 16,
    },
    Tabs: {
      inkBarColor: '#202124',
      itemActiveColor: '#202124',
      itemHoverColor: '#202124',
      itemSelectedColor: '#202124',
      horizontalItemGutter: 30,
    },
    Input: {
      activeBorderColor: '#bbb8b0',
      hoverBorderColor: '#bbb8b0',
      activeShadow: '0 0 0 3px rgba(232, 93, 53, 0.1)',
    },
    Select: {
      activeBorderColor: '#bbb8b0',
      hoverBorderColor: '#bbb8b0',
      activeOutlineColor: 'rgba(232, 93, 53, 0.1)',
    },
    Modal: {
      titleFontSize: 18,
      titleLineHeight: 1.4,
      contentBg: '#ffffff',
      headerBg: '#ffffff',
    },
    Drawer: {
      colorBgElevated: '#ffffff',
    },
    Tooltip: {
      colorBgSpotlight: '#202124',
    },
  },
};
